import React, { useEffect, useState } from 'react';
import styles from './resend-otp.module.scss';

export function ResendOTP(props) {
  const { currentTime, setCurrentTime, onSubmit } = props;
  const timeInMinutes = Math.floor(currentTime / 60);
  const timeInSeconds = currentTime % 60;

  useEffect(
    () => {
      const interval = setInterval(() => {
        if (currentTime === 0) {
          clearInterval(interval);
        } else {
          setCurrentTime(currentTime - 1);
        }
      }, 1000);
      return () => clearInterval(interval);
    },
    [currentTime]
  );

  return (
    <div className={styles['container']}>
      <div className={styles['resend-otp-msg']}>
        {currentTime ? (
          <>
            <span>Resend code in </span>
            <span>{`${timeInMinutes}:${timeInSeconds}${
              timeInMinutes >= 1 ? 'm' : 's'
            }`}</span>
          </>
        ) : (
          <span className={styles['resend-btn']} onClick={onSubmit}>
            Re-send OTP
          </span>
        )}
      </div>
    </div>
  );
}

export default ResendOTP;
